var _text, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewAllArabic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 16,
    viewBox: "0 0 42 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 10,
    fill: "#9C4900",
    fontFamily: "Arial",
    fontSize: 10,
    textAnchor: "middle"
  }, "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.796875 12.6C0.575961 12.6 0.396875 12.7791 0.396875 13C0.396875 13.2209 0.575961 13.4 0.796875 13.4L0.796875 12.6ZM41.0797 13.2828C41.2359 13.1266 41.2359 12.8734 41.0797 12.7172L38.5341 10.1716C38.3779 10.0154 38.1247 10.0154 37.9684 10.1716C37.8122 10.3278 37.8122 10.581 37.9684 10.7373L40.2312 13L37.9684 15.2627C37.8122 15.4189 37.8122 15.6722 37.9684 15.8284C38.1247 15.9846 38.3779 15.9846 38.5341 15.8284L41.0797 13.2828ZM0.796875 13.4L40.7969 13.4L40.7969 12.6L0.796875 12.6L0.796875 13.4Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllArabic);
export default __webpack_public_path__ + "static/media/view-all_arabic.92c5ee4b2391afd968d883413049132b.svg";
export { ForwardRef as ReactComponent };